import React from "react"
import QuestionMark from "../../assets/QuestionMark.svg"
import { Tooltip } from "antd"
import Image from "./Image"

const IconTooltip = ({ className, title, onClick, zIndex, ...props }) => {
  return (
    <Tooltip title={title} zIndex={zIndex} placement="right" color={"#fff"} overlayInnerStyle={style.containerStyle}>
      <Image src={QuestionMark} onClick={onClick} style={{ marginLeft: 5, cursor: "pointer" }} alt={"Question Mark"} width={"18.53px"} height={"17.96px"}/>
    </Tooltip>
  )
}

const style = {
  containerStyle: {
    background: "#fff",
    padding: 5,
    fontSize: 12,
    lineHeight: "16px",
    color: "#444",
    borderRadius: 7,
    width: 150,
  },
}

export default IconTooltip
